import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React, { createContext, Fragment } from 'react';
import { AlertClose } from './alert-close';
import { AlertIcon } from './alert-icon';
import { AlertTitle } from './alert-title';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export { AlertClose, AlertIcon, AlertTitle };
var variantPath = getVariantPath({
  id: 'alert'
});
export var AlertVariantContext = /*#__PURE__*/createContext();
/**
 * Alerts call out important information inline with content within a page
and can visually express negative, positive and neutral context.
They do not self-dismiss and have the option to include an icon, title, a close icon and content.
 */

export var Alert = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      title = _ref.title,
      icon = _ref.icon,
      closeButton = _ref.closeButton,
      _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "title", "icon", "closeButton", "as", "children"]);

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: variantPath(variant)
    }
  }, props), {}, {
    children: _jsxs(AlertVariantContext.Provider, {
      value: variant,
      children: [(icon || title || closeButton) && _jsxs("div", {
        sx: {
          variant: "".concat(variantPath(variant), ".header")
        },
        children: [icon && _jsx(AlertIcon, {
          children: icon
        }), title && _jsx(AlertTitle, {
          children: title
        }), closeButton && _jsxs(Fragment, {
          children: [_jsx("div", {
            sx: {
              flexGrow: 1
            }
          }), closeButton]
        })]
      }), children]
    })
  }));
});
Alert.propTypes = {
  /**
   * The element to use as icon, hidden if undefined
   */
  icon: PropTypes.node,

  /**
   * The element to use for title, hidden if undefined
   */
  title: PropTypes.node,

  /**
   * The element to use for close button, hidden if undefined
   */
  closeButton: PropTypes.element,

  /**
   * Alert variant used to style it
   */
  variant: PropTypes.oneOf(['info', 'error', 'warning', 'success', 'primary']).isRequired
};
Alert.defaultProps = {
  variant: 'info'
};